/** Hotspots sit beside Background, not inside it — use shared wrapper first. */
export function getImageMapBoundsEl(
  fromEl: Element | null | undefined
): Element | null {
  if (!fromEl) return null;
  return (
    fromEl.closest('[data-image-map-anchor="true"]') ??
    fromEl.closest('[data-image-container="true"]')
  );
}
